import { WarpedComposition } from "@/components/Composition/WarpedComposition"
import { InfoCard } from "../../common/InfoCard"
import { LabelRow } from "../../common/LabelRow"
import { StreamName } from "../../common/StreamName"
import { ManualInputRow } from "../../common/ManualInputRow"
import { UnitProps } from "../../unitTypes"
import { addManualInputThunk, deleteManualInputThunk } from "@/store/flowsheet/actions"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "@/store"
import { PropertySetSelect } from "../../common/PropertySetSelect"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"

export const LimitMain = (props: UnitProps) => {
  const {unit, data} = props;
  const inData = data?.vars?.IN || {} as any
  const outData = data?.vars?.OUT || {} as any
  const dispatch = useDispatch<AppDispatch>()
  const flowSimulation = useSelector(getFlowSimulationSelector)

  const onCompositionChange = async (val: number[]) => {
    dispatch(addManualInputThunk({
      data: {dvars: [{unitId: unit.id, attribute: ':OUT:xi_$1', value: val}]},
      params: {sId: flowSimulation?.id}
    }))
  }

  const onCompositionDelete = async () => {
    dispatch(deleteManualInputThunk({
      data: {dvars: [{unitId: unit.id, attribute: ':OUT:xi_$1'}]},
      params: {sId: flowSimulation?.id}
    }))
  }
  
  return <div>
    <InfoCard title="Inlet:">
      <LabelRow label="Stream" value={<StreamName unitId={inData.unitId}/>}/>
      <ManualInputRow label="Molar Flow" dimCode='MOL_F' data={outData.F} attrKey=':OUT:F' unitId={unit.id}/>
    </InfoCard>

    <InfoCard title="Outlet:" className="mt-1">
      <LabelRow label="Stream" value={<StreamName unitId={outData.unitId}/>}/>
      <ManualInputRow label="Molar Flow" dimCode='MOL_F' data={outData.F} attrKey=':OUT:F' unitId={unit.id}/>
    </InfoCard>

    <WarpedComposition className="mt-1" setName={data?.args?.tpps} value={outData.xi_$1} onChange={onCompositionChange} onDelete={onCompositionDelete}/>

    <ManualInputRow label="Pressure" dimCode='PRES' data={outData.P} attrKey=':OUT:P' unitId={unit.id}/>
    <ManualInputRow label="Temperature" dimCode='TEMP' data={outData.T} attrKey=':OUT:T' unitId={unit.id}/>
    {outData.VF === 'SC' && <LabelRow label="Molar Vapor Fraction" value="Supercritical" />}
    {outData.VF !== 'SC' && <ManualInputRow label="Molar Vapor Fraction"  dimCode='PF' data={outData.VF} attrKey=':OUT:VF' unitId={unit.id} />}
    <ManualInputRow label="Enthalpy" dimCode='MOL_H' data={outData.h} attrKey=':OUT:h' unitId={unit.id}/>
    <ManualInputRow label="Entropy" dimCode='MOL_S' data={outData.s} attrKey=':OUT:s' unitId={unit.id}/>
    <PropertySetSelect unitId={unit.id} value={data?.args?.tpps} />
  </div>
}